export default "__VITE_ASSET__B65eMDn4__"